const CONVERSATIONAL_PREFIXES = [
  'why', 'how', 'when', 'what', 'which', 'who', 'where',
  'can i', 'should i', 'do i', 'tell me', 'explain',
];

export const isConversational = (query: string): boolean => {
  const q = query.trim().toLowerCase();
  if (!q) return false;
  if (q.endsWith('?')) return true;
  return CONVERSATIONAL_PREFIXES.some((p) => q === p || q.startsWith(p + ' '));
};
